var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBorrower = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7526_1707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.75 28H5.25C2.35025 28 0 25.6497 0 22.75V5.25C0 2.35025 2.35025 0 5.25 0H22.75C25.6497 0 28 2.35025 28 5.25V22.75C28 25.6497 25.6497 28 22.75 28Z",
    fill: "#619BF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88959 17.2086C10.8259 17.2086 11.5849 16.4251 11.5849 15.4586C11.5849 14.4921 10.8259 13.7086 9.88959 13.7086C8.95329 13.7086 8.19427 14.4921 8.19427 15.4586C8.19427 16.4251 8.95329 17.2086 9.88959 17.2086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4434 18.0836H8.335C7.47802 18.0836 6.78125 18.8029 6.78125 19.6875V20.5625C6.78125 20.804 6.97113 21 7.20508 21H12.5733C12.8072 21 12.9971 20.804 12.9971 20.5625V19.6875C12.9971 18.8029 12.3003 18.0836 11.4434 18.0836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3546 7H10.5957C10.0532 7 9.60651 7.46112 9.60651 8.02112V12.8511C9.69721 12.8398 9.79299 12.8336 9.88878 12.8336C11.1942 12.8336 12.2732 13.8547 12.4148 15.1672H13.5625V17.0625C13.5625 17.255 13.6812 17.4239 13.8617 17.4825C13.9016 17.4939 13.9465 17.5 13.9863 17.5C14.122 17.5 14.2576 17.43 14.3364 17.3075L15.7605 15.1664H19.3546C19.8971 15.1664 20.3438 14.7053 20.3438 14.1453V8.02025C20.3438 7.46113 19.8971 7 19.3546 7ZM14.7636 10.6461H14.9052C15.4892 10.6461 15.9648 11.137 15.9648 11.7399C15.9648 12.2141 15.6689 12.6158 15.2587 12.7663V12.9789C15.2587 13.2204 15.0688 13.4164 14.8348 13.4164C14.6009 13.4164 14.411 13.2204 14.411 12.9789V12.8328H14.1288C13.8948 12.8328 13.7049 12.6368 13.7049 12.3953C13.7049 12.1538 13.8948 11.9578 14.1288 11.9578H14.9061C15.023 11.9578 15.118 11.8598 15.118 11.739C15.118 11.6183 15.023 11.5203 14.9061 11.5203H14.7645C14.1805 11.5203 13.7049 11.0294 13.7049 10.4265C13.7049 9.95225 14.0008 9.55063 14.411 9.40013V9.1875C14.411 8.946 14.6009 8.75 14.8348 8.75C15.0688 8.75 15.2587 8.946 15.2587 9.1875V9.33362H15.5409C15.7749 9.33362 15.9648 9.52962 15.9648 9.77112C15.9648 10.0126 15.7749 10.2086 15.5409 10.2086H14.7636C14.6467 10.2086 14.5517 10.3066 14.5517 10.4274C14.5517 10.5472 14.6467 10.6461 14.7636 10.6461Z",
    fill: "#C2D8FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7526_1707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBorrower);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Borrower.0ffbe625c3481bd095937bf77813f4aa.svg";